
import {inject, PLATFORM} from 'aurelia-framework';
import {DialogService, DialogController} from 'aurelia-dialog';
import {CommonDialogs} from '../../../../../../controls/dialogs/common-dialogs/common-dialogs';
import {GroupService} from '../../../../../../../services/group/group-service';
import {I18N} from 'aurelia-i18n';
import {AddMember} from '../../add-member';
import {AddMemberResult} from '../../add-member-result/add-member-result';

@inject(Element, I18N, DialogService, DialogController, GroupService, CommonDialogs)
export class OnboardBulk {

  emails = [];
  emailEntered = '';
  disableInvite = false;
  parsedInfo = [];
  step = 1;
  processing = false;
  processingFile = false;
  fileList = [];
  onboardMessage = '';
  sendInvite = false;
  groupId: number;
  fileInput: HTMLInputElement;
  file: File;

  constructor(private element: Element, private i18n: I18N, private dialog: DialogService, private controller: DialogController, private __groupService: GroupService, private commonDialogs: CommonDialogs) {
  }
  activate(groupId) {
    this.groupId = groupId;
  }
  attached() {
    this.fileInput = this.element.querySelector('input');
  }
  back() {
    if (this.step > 1) {
      this.step -= 1;
      this.clearFileContent();
    } else {
      this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/add-member'), model: this.groupId}).then(()=>{ // @ts-ignore
        this.controller.close();});
    }
  }

  allowDrop(ev) {
    ev.preventDefault();
  }
  onAddedFile(ev) {
    ev.preventDefault();
    if (!this.processingFile) {
      this.processingFile = true;
      if (ev.type === 'change') {
        if (ev.target.files && ev.target.files[0]) {
          this.file = ev.target.files[0];
        }
      } else if (ev.type === 'drop') {
        if (ev.dataTransfer.files && ev.dataTransfer.files[0]) {
          this.file = ev.dataTransfer.files[0];
        }
      }
      if (this.file) {
        this.uploadFile(this.file);
      }
    }
  }
  triggerBrowse() {
    this.fileInput.click();
  }
  uploadFile(file) {
    if (file) {
      let {response} = this.__groupService.uploadFile(file);
      response.then(()=>{
        this.parseFile(file.name);
      }).catch(error=>{
        let message = (error.responseType !== 'html' && error.response) ? error.response : this.i18n.tr('groups.add-members.parse-error');
        this.commonDialogs.showMessage(message, this.i18n.tr('groups.add-members.onboarding'), ['Ok']);
        this.processingFile = false;
      });
    }
  }
  parseFile(fileName) {
    if (fileName) {
      let {response} = this.__groupService.preParseBulkOnboard(this.groupId, fileName);
      response.then((res)=>{
        if (res.users) {
          this.parsedInfo = res.users;
          this.processingFile = false;
          this.step = 2;
        }
      }).catch(error=>{
        let message = (error.responseType !== 'html' && error.response) ? error.response : this.i18n.tr('groups.add-members.parse-error');
        this.commonDialogs.showMessage(message, this.i18n.tr('groups.add-members.onboarding'), ['Ok']);
        this.processingFile = false;
      });
    }
  }
  onboard() {
    if (this.file && !this.processing ) {
      this.processing = true;
      let {response} = this.__groupService.onboardFromFile(this.groupId, this.file, this.sendInvite);
      response.then((res)=>{
        // this.step = 3;
        // this.onboardMessage = 'groups.onboard-members.bulk-success';
        // let message = this.i18n.tr('groups.onboard-members.bulk-success');
        // this.processing = false;
        // this.commonDialogs.showMessage(message, this.i18n.tr('groups.add-members.onboard'), ['Ok']).then(()=>{
        //   this.controller.close();
        // });
        this.responseDialog(res);
      }).catch((error) => {
        let message = (error.responseType !== 'html' && error.response) ? error.response : this.i18n.tr('groups.add-members.bulk-error');
        this.processing = false;
        this.commonDialogs.showMessage(message, this.i18n.tr('groups.add-members.onboard'), ['Ok']);
      });
    } else if (!this.file) {
      let message = this.i18n.tr('groups.add-members.new-file-needed');
      this.commonDialogs.showMessage(message, this.i18n.tr('groups.add-members.onboard'), ['Ok']);
    }
  }
  clearFileContent() {
    this.file = null;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
  }
  responseDialog(response) {
    this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/add-member-result/add-member-result'), model: {action: 'onboard', profilesArray: response.users}}).then(()=>{ // @ts-ignore
      this.controller.close();});
  }
}

